import { get, post, put, del, search } from 'redux/shelf/api';
import session from 'lib/session';
import { createReducer } from 'redux/shelf';

export const actions = {
  getSeamlessCollectionsStatus: get`webhooks-manager/smart-collection`(),
  enableSeamlessCollections: post`webhooks-manager/smart-collection`(),
  disableSeamlessCollections: del`webhooks-manager/smart-collection`(),
  getProductWebhooksStatus: get`webhooks-manager/product`(),
  enableProductWebhooks: post`webhooks-manager/product`(),
  disableProductWebhooks: del`webhooks-manager/product`(),
  getInventoryLevelWebhookStatus: get`webhooks-manager/inventory-level`(),
  enableInventoryLevelWebhook: post`webhooks-manager/inventory-level`(),
  disableInventoryLevelWebhook: del`webhooks-manager/inventory-level`(),
};

export const reducer = createReducer(actions, {
  [actions.getSeamlessCollectionsStatus]: (s, { payload, meta }) => ({
    ...s,
    entity: payload.entity.webhooksConfigured,
  }),
  [actions.enableSeamlessCollections]: (s) => ({
    ...s,
    entity: true,
  }),
  [actions.disableSeamlessCollections]: (s) => ({
    ...s,
    entity: false,
  }),
  [actions.getProductWebhooksStatus]: (s, { payload }) => ({
    ...s,
    product: payload.entity.webhooksConfigured,
  }),
  [actions.enableProductWebhooks]: (s) => ({
    ...s,
    product: true,
  }),
  [actions.disableProductWebhooks]: (s) => ({
    ...s,
    product: false,
  }),
  [actions.getInventoryLevelWebhookStatus]: (s, { payload }) => ({
    ...s,
    inventoryLevel: payload.entity.webhooksConfigured,
  }),
  [actions.enableInventoryLevelWebhook]: (s) => ({
    ...s,
    inventoryLevel: true,
  }),
  [actions.disableInventoryLevelWebhook]: (s) => ({
    ...s,
    inventoryLevel: false,
  }),
});
